import { message } from 'antd';
import omit from 'lodash/omit';
import { takeLatest, put } from 'redux-saga/effects';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
import { updateDocumentTemplateTaskAction } from '../../actions';
import { updateDocumentTemplateTask } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';
function* updateDocumentTemplateTaskSaga(action) {
    const { payload: { docId, resourceSectionId, task: _task } } = action;
    const task = {
        ...omit(_task, [
            'resourceSectionId',
            'resourceType'
        ]),
        taskId: _task.taskId
    };
    try {
        yield put(updateDocumentTemplateTask({
            docId,
            resourceSectionId,
            task
        }));
        const template = yield TemplatesAPI.getById(_task.taskId);
        yield TemplatesAPI.save({
            ...template,
            templateContent: {
                ...template.templateContent,
                ...task
            }
        });
        yield saveDocumentTemplate(docId);
    } catch (error) {
        logger.error('an error updating the task in the document', {
            error
        });
        message.error('There was an error updating the task in the document');
    }
}
export const watchUpdateDocumentTemplateTaskSaga = function*() {
    yield takeLatest(updateDocumentTemplateTaskAction.type, updateDocumentTemplateTaskSaga);
};
